export default {
  hero: {
    title: "Terms and Conditions"
  },
  toc: {
    title: "Contents"
  },
  sections: [
    {
      id: "section1",
      title: "1 Scope",
      blocks: [
        "These Terms and Conditions exclusively govern the use of the digital platform NutriBot.",
        "Operator of the platform:\nEat&Drink 7day GmbH\nFrauenfelderstrasse 4\n8252 Schlatt\nSwitzerland",
        "By accessing or using NutriBot, a legally binding agreement is formed.",
        "The user confirms that these Terms have been read, understood, and accepted.",
        "Any conflicting or additional terms of the user are explicitly excluded."
      ]
    },
    {
      id: "section2",
      title: "2 Nature of the Service",
      blocks: [
        "NutriBot is a purely technical system for the automated generation of content.",
        "The platform does not provide any form of advice, recommendation, or evaluation.",
        "All content is non-binding, generic, and provided without any guarantee of accuracy, suitability, or completeness.",
        "No individual or personal assessment is performed.",
        "No specific result is owed."
      ]
    },
    {
      id: "section3",
      title: "3 No Reliance",
      blocks: [
        "The user expressly acknowledges:",
        [
          "that the content must not be relied upon for any decision-making",
          "that no expectation of accuracy, completeness, or reliability exists",
          "that no legally protected reliance relationship is created"
        ],
        "All use is made without reliance on the content."
      ]
    },
    {
      id: "section4",
      title: "4 Full User Responsibility",
      blocks: [
        "The user bears sole and unrestricted responsibility for:",
        [
          "all decisions",
          "all actions",
          "all consequences"
        ],
        "arising from or related to the use of NutriBot.",
        "All use is entirely at the user’s own risk."
      ]
    },
    {
      id: "section5",
      title: "5 Medical Disclaimer",
      blocks: [
        "NutriBot is not intended for medical use.",
        "The content must not be used for diagnosis, treatment, or prevention of any condition.",
        "The user is required to consult qualified professionals for any health-related matters."
      ]
    },
    {
      id: "section6",
      title: "6 AI Limitations",
      blocks: [
        "The user acknowledges:",
        [
          "all content is generated automatically",
          "no human review or validation takes place",
          "errors, inconsistencies, and inaccuracies are inherent"
        ],
        "No guarantee of correctness or suitability is provided."
      ]
    },
    {
      id: "section7",
      title: "7 Acceptable Use",
      blocks: [
        "The user agrees not to:",
        [
          "misuse the platform",
          "use it for unlawful purposes",
          "perform automated access or scraping",
          "bypass technical protections",
          "resell or commercially exploit content",
          "use the platform to develop competing systems"
        ],
        "The operator may suspend or terminate access at any time without notice."
      ]
    },
    {
      id: "section8",
      title: "8 License",
      blocks: [
        "The user is granted a revocable, non-transferable, non-exclusive license for personal use only.",
        "All rights remain with the operator."
      ]
    },
    {
      id: "section9",
      title: "9 Availability",
      blocks: [
        "No guarantee is given regarding:",
        [
          "availability",
          "functionality",
          "error-free operation",
          "data integrity"
        ],
        "The service may be modified, restricted, or discontinued at any time."
      ]
    },
    {
      id: "section10",
      title: "10 Limitation of Liability",
      blocks: [
        "To the maximum extent permitted by law, all liability is excluded.",
        "This includes, in particular:",
        [
          "any damages of any kind",
          "direct and indirect damages",
          "financial losses",
          "data loss",
          "user decisions",
          "health-related consequences"
        ],
        "Liability exists only in cases of intentional misconduct or gross negligence."
      ]
    },
    {
      id: "section11",
      title: "11 Extended Disclaimer",
      blocks: [
        "The operator assumes no responsibility for:",
        [
          "interpretation of content",
          "application of content",
          "outcomes resulting from use"
        ],
        "The user expressly waives any claims, to the extent permitted by law."
      ]
    },
    {
      id: "section12",
      title: "12 Indemnification",
      blocks: [
        "The user agrees to fully indemnify and hold harmless the operator from:",
        [
          "all third-party claims",
          "all damages",
          "all costs"
        ],
        "including legal fees.",
        "This applies to all consequences arising from:",
        [
          "use of the platform",
          "violation of these Terms",
          "unlawful conduct by the user"
        ]
      ]
    },
    {
      id: "section13",
      title: "13 Subscriptions",
      blocks: [
        "Subscriptions renew automatically.",
        "No refunds are granted, to the extent permitted by law."
      ]
    },
    {
      id: "section14",
      title: "14 Termination",
      blocks: [
        "The operator may terminate or suspend access at any time without providing reasons."
      ]
    },
    {
      id: "section15",
      title: "15 Data Protection (Link)",
      blocks: [
        "Processing of personal data is governed by a separate Privacy Policy."
      ]
    },
    {
      id: "section16",
      title: "16 Amendments",
      blocks: [
        "These Terms may be modified at any time.",
        "Continued use constitutes acceptance of the updated Terms."
      ]
    },
    {
      id: "section17",
      title: "17 Governing Law and Jurisdiction",
      blocks: [
        "Swiss law applies exclusively.",
        "The place of jurisdiction is Schlatt, Switzerland, to the extent permitted by law."
      ]
    },
    {
      id: "section18",
      title: "18 Severability",
      blocks: [
        "If any provision is invalid, the remaining provisions remain unaffected.",
        "The invalid provision shall be replaced by one that most closely reflects its economic intent."
      ]
    }
  ],
  finalStatement: "Final Clause\n\nThe user expressly acknowledges that the use of NutriBot is entirely at their own risk and does not create any claims against Eat&Drink 7day GmbH."
};